<button
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="toggleNotifications()"
  [class.open]="notificationsOpen"
  mat-icon-button
  title="Notificações"
  class="notification-button"
>
  <mat-icon
    [matBadge]="unreadCount"
    [matBadgeHidden]="unreadCount === 0"
    matBadgeColor="warn"
    matBadgeSize="small"
  >
    notifications
  </mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="notificationsOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="notificationsOpen = false"
  (detach)="notificationsOpen = false"
>
  <div class="notification-panel">
    <div class="notification-header">
      <h2>Notificações</h2>
      <div class="header-actions">
        <button
          mat-icon-button
          [class.active]="showUnreadOnly"
          (click)="toggleUnreadFilter()"
          [matTooltip]="
            showUnreadOnly ? 'Mostrar todas' : 'Mostrar apenas não lidas'
          "
          matTooltipPosition="below"
        >
          <mat-icon>{{
            showUnreadOnly ? "filter_alt" : "filter_alt_off"
          }}</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="markAllAsRead()"
          [disabled]="unreadCount === 0"
          matTooltip="Marcar todas como lidas"
          matTooltipPosition="below"
        >
          <mat-icon>done_all</mat-icon>
        </button>
      </div>
    </div>

    <div
      class="notifications-list"
      infiniteScroll
      [infiniteScrollDistance]="0.5"
      [infiniteScrollThrottle]="200"
      [scrollWindow]="false"
      [infiniteScrollDisabled]="isLoadingMore || !hasMoreData"
      (scrolled)="onScrollDown()"
    >
      <ng-container *ngIf="groupedNotifications.length > 0">
        <div
          *ngFor="let group of groupedNotifications; trackBy: trackByGroup"
          class="time-group"
        >
          <div class="time-label">{{ group.label }}</div>

          <div
            *ngFor="
              let notification of group.notifications;
              trackBy: trackByNotification
            "
            class="notification-item"
            [class.unread]="!notification.viewed"
            [attr.data-type]="notification.type"
            (click)="openNotification(notification)"
          >
            <div
              class="notification-avatar"
              [class]="'type-' + notification.type.toLowerCase()"
            >
              <mat-icon class="avatar-icon">{{
                getNotificationIcon(notification.type)
              }}</mat-icon>
            </div>

            <div class="notification-content">
              <div class="notification-header-info">
                <span class="notification-type-badge">{{
                  getNotificationTypeLabel(notification.type)
                }}</span>
              </div>

              <div class="notification-message">
                {{ notification.message }}
              </div>

              <div class="notification-meta">
                <span class="notification-time">{{
                  getRelativeTime(notification.createdAt)
                }}</span>
              </div>
            </div>

            <div class="notification-actions">
              <div class="unread-indicator" *ngIf="!notification.viewed"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="loading-more" *ngIf="isLoadingMore">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Carregando mais...</span>
      </div>

      <div
        class="empty-state"
        *ngIf="groupedNotifications.length === 0 && !isLoadingMore"
      >
        <mat-icon>{{
          showUnreadOnly ? "notifications_active" : "notifications_none"
        }}</mat-icon>
        <p class="empty-title">
          {{ showUnreadOnly ? "Tudo em dia!" : "Nenhuma notificação" }}
        </p>
        <p class="empty-subtitle">
          {{
            showUnreadOnly
              ? "Você não tem notificações não lidas"
              : "Quando houver novidades, você verá aqui"
          }}
        </p>
      </div>
    </div>
  </div>
</ng-template>
